var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"text-xs-center"},[_c('setStoreTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }